import { fetchInitialProjectTemplateNameWithRethrow } from '../../services/initial-project-template-name/index.tsx';

export const actions = {
	fetchInitialProjectTemplateName: fetchInitialProjectTemplateNameWithRethrow,
};
